import ModalAlerta from "global/component/Genericos/ModalAlerta/ModalAlerta";
import Toaster from "global/component/Genericos/Toaster/Toaster";
import { hideModal, showModal } from "global/context/action/modal/modal";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { resetOrdenEstudio } from "_+_Portal/context/Actions/ordenEstudio/ordenEstudio";
import { PortalContext } from "_+_Portal/context/Provider";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import MotivoRechazo from "_+_Portal/_-_Autocheckin/components/genericos/MotivoRechazo/MotivoRechazo";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import {
  setOrden,
  wsGetEstadoOrden,
} from "_+_Portal/_-_Autocheckin/context/action/orden";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";
import { wsGetTurnoByIdQr } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { proximoPaso } from "../PagesFun";
import { IonSpinner } from "@ionic/react";
import { ContainerSubirOrden, Paso2Body } from "./localStyle";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import SubirOrdenComponent from "_+_Portal/_-_Autocheckin/components/genericos/SubirOrdenComponent/SubirOrdenComponent";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import CountdownTimer from "_+_Portal/_-_Autocheckin/components/genericos/CountdownTimer/CountdownTimer";

const SubirOrden = ({ turnoActual, setLoading }) => {
  const { modalDispatch, toasterDispatch, toasterState, modalAlertaState } =
    useContext(GlobalContext);
  const {
    ordenEstudioState,
    selectDropDownState,
    ordenLaboratorioState,
    ordenEstudioDispatch,
  } = useContext(PortalContext);

  const {
    turnosSeleccionadosState,
    ordenDispatch,
    ordenState,
    rutaState,
    pasoDispatch,
    rutaDispatch,
    turnosAutoCheckInDispatch,
    puntoControlDispatch,
  } = useContext(AutocheckContext);

  let config = localStorage.getItem("config");
  let minEstadoOrden = JSON.parse(config).minEstadoOrden;

  const [flgPendiente, setFlgPendiente] = useState(false);
  const [loop, setLoop] = useState(false);
  const [tiempoEspera, setTiempoEspera] = useState("1,5");
  const [txtTiempoEspera, setTxtTiempoEspera] = useState("");

  const interval = useRef();
  const isComponentMounted = useRef(true);

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados.data;

  const turno = listTurnosSeleccionado[turnoActual];

  const txtPendiente =
    "Aguarde mientras controlamos la orden ingresada en el sistema";
  const txtSiguienteEnCola =
    "Usted es el siguiente en la fila de verificación de orden médica";

  //----------------------Funciones----------------------------
  const dismiss = (limpiarOrden) => {
    hideModal()(modalDispatch);
    if (limpiarOrden) {
      setOrden([])(ordenDispatch);
    }
  };
  const nextStepEstadoOrden = (data, isCorrect) => {
    if (isCorrect) {
      //tiempo de espera
      if (data.tiempoEspera !== undefined && data.tiempoEspera !== null) {
        if (data.tiempoEspera !== "" && data.tiempoEspera !== tiempoEspera) {
          setTiempoEspera(data.tiempoEspera);
          setTxtTiempoEspera(txtPendiente);
        } else {
          setTxtTiempoEspera(txtSiguienteEnCola);
        }
      }
      if (data.estadoOrden === "Validado") {
        setFlgPendiente(false);
        siguientePaso();
      } else if (data.estadoOrden === "Rechazado") {
        setFlgPendiente(false);
        showModal(
          <MotivoRechazo
            idturno={turno.idturno}
            motivoRechazo={data.motivoRechazo}
            motivoRechazoObservacion={data.motivoRechazoObservacion}
            motivoRechazoRecepcion={data.motivoRechazoRecepcion}
          />,
          "Orden Rechazada",
          dismiss,
          false,
          {},
          "centro",
          true
        )(modalDispatch);
        stopLoopSubirOrden();
      }
    } else {
      setFlgPendiente(false);
      stopLoopSubirOrden();
    }
  };

  const loopSubirOrden = () => {
    let msEstadoOrden;
    if (
      minEstadoOrden !== undefined &&
      minEstadoOrden !== null &&
      minEstadoOrden > 0
    ) {
      msEstadoOrden = minEstadoOrden * 10000;
    } else {
      msEstadoOrden = 30000; // 30 segundos por defecto
    }
    setFlgPendiente(true);
    hideModal()(modalDispatch);

    // 1) llamada inicial
    wsGetEstadoOrden(turno.idturno, true, nextStepEstadoOrden)(ordenDispatch);

    interval.current = setInterval(() => {
      if (isComponentMounted) {
        wsGetEstadoOrden(
          turno?.idturno,
          true,
          nextStepEstadoOrden
        )(ordenDispatch);
      } else {
        stopLoopSubirOrden();
      }
    }, msEstadoOrden);
    return interval.current;
  };

  const stopLoopSubirOrden = useCallback(() => {
    if (interval.current) {
      clearInterval(interval.current);
      interval.current = null;
    }
  }, []);

  const handleClickVolver = () => {
    stopLoopSubirOrden();
    setPaso("TurnosDelDia")(pasoDispatch);
  };

  const siguientePaso = () => {
    const ruta = rutaState.ruta.data;
    const idPacFamiliar = selectDropDownState.selectDropDown.selectGlobal
      .pacienteElegido?.paciente?.codigo
      ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ?.paciente?.codigo
      : false;
    let nextStepTurnoById = (isCorrect, data) => {
      let pathUpdated = [];
      if (isCorrect) {
        if (
          data.resumen.validaOnline ||
          data.resumen.validaOnlineEstado === "Pendiente"
        ) {
          pathUpdated.push("ValidarCobertura");
        }
        if (data?.resumen?.monto) {
          pathUpdated.push("AbonarMP");
        }
        pathUpdated.push(ruta.pop());
        setRuta(proximoPaso(pathUpdated, setPaso, pasoDispatch))(rutaDispatch);
      }
    };

    setLoading("Actualizando información de turno...");
    wsGetTurnoByIdQr(
      turno.idturno,
      nextStepTurnoById
    )(turnosAutoCheckInDispatch);
  };

  const enviarPuntoControl = () => {
    setLoading(true);
    const idTipoPuntoControl = 5;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  //prueba
  const handleEnd = () => {
    //si termino y no se completo la orden aun, se resetea al ultimo estado
    setTiempoEspera(tiempoEspera);
  };

  const formatter = (secs) => {
    if (secs > 60) return "Queda más de un minuto";
    if (secs > 30) return "Menos de un minuto";
    if (secs > 10) return "Se acaba pronto…";
    if (secs > 0) return "¡Ya casi!";
    return "¡Tiempo finalizado!";
  };

  //----------------------Funciones----------------------------

  //----------------------useEffects----------------------------

  useEffect(() => {
    if (
      ordenEstudioState.ordenEstudio.eliminado === "" ||
      ordenLaboratorioState.ordenLaboratorio.eliminado === ""
    ) {
      hideModal()(modalDispatch);
      showToaster(
        {
          texto: "Orden eliminada exitosamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      resetOrdenEstudio()(ordenEstudioDispatch);
    }
    //eslint-disable-next-line
  }, [
    ordenEstudioState.ordenEstudio.eliminado,
    ordenLaboratorioState.ordenLaboratorio.eliminado,
  ]);

  useEffect(() => {
    let idInterval;
    if (!loop && turno.tieneFotoOrden) {
      idInterval = loopSubirOrden();
      setLoop(true);
    }
    return () => {
      clearInterval(idInterval);
    };
  }, []);

  //----------------------useEffects----------------------------

  return (
    <LayoutPasos
      volverTo={"/autocheckin/resumen"}
      handleClick={handleClickVolver}
      type={"no-circle"}
      title={"orden médica"}
      children={
        <>
          {toasterState.toaster.show && <ToasterV2 />}
          {modalAlertaState.modalAlerta.show && <ModalAlerta />}
          <CardBlueHeart
            medico={turno.medico ? turno.medico : turno.especialidad}
            turnoTitle={turno.especialidad}
            pasoActual={turnoActual + 1}
            pasoTotal={listTurnosSeleccionado.length}
          />
          <ContainerSubirOrden>
            <PasoBar paso={"SubirOrden"} />
          </ContainerSubirOrden>
          <Paso2Body>
            {ordenState.orden.loading && (
              <div className="container-spinnerEstadoOrden">
                <div>
                  <IonSpinner />
                </div>
                <div>
                  <p>Verificando estado orden médica...</p>
                </div>
              </div>
            )}
            {!flgPendiente ? (
              <SubirOrdenComponent
                turno={turno}
                callback={loopSubirOrden}
                enviarPuntoControl={enviarPuntoControl}
              />
            ) : (
              <div className="container-texto-promocional">
                {txtTiempoEspera !== "" ? (
                  <CountdownTimer
                    text={txtTiempoEspera}
                    timeString={tiempoEspera} // 4.5 minutos = 270 s
                    onComplete={handleEnd}
                    textFormatter={formatter}
                  />
                ) : (
                  ""
                )}
              </div>
            )}
          </Paso2Body>
        </>
      }
    ></LayoutPasos>
  );
};

export default SubirOrden;
